/* eslint-disable */
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Search as SearchIcon, Inbox as InboxIcon } from '@mui/icons-material';

interface EmptyStateProps {
  type: 'no-srs' | 'no-search-results';
  onClearSearch?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ type, onClearSearch }) => {
  if (type === 'no-search-results') {
    return (
      <Box
        data-testid="empty-search-results"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '300px',
          p: 4,
        }}
      >
        <SearchIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
        <Typography variant="h6" color="text.secondary" gutterBottom>
          No SRs match your search
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Try adjusting your search query or clear the search to see all SRs
        </Typography>
        {onClearSearch && (
          <Button variant="outlined" onClick={onClearSearch}>
            Clear Search
          </Button>
        )}
      </Box>
    );
  }

  // type === 'no-srs'
  return (
    <Box
      data-testid="empty-srs"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
        p: 4,
      }}
    >
      <InboxIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        No SR tickets found for the selected area
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Try selecting a different area
      </Typography>
    </Box>
  );
};
